import React from "react";

function New() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    offerSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-sans">
      {/* BLOCO 1 — HERO */}
      <section className="py-16 px-4 bg-[#0a0a0a]">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block bg-[#F5C518] text-[#0a0a0a] px-4 py-2 text-xs font-black uppercase mb-6">
            PARA QUEM JÁ SABE QUE DEVIA TER COMEÇADO HÁ TRÊS MESES
          </div>
          
          <h1 className="text-4xl md:text-6xl font-black uppercase leading-tight mb-8">
            Você não precisa de mais um curso sobre IA.<br/>
            Você precisa parar de assistir curso sobre IA.
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-12 max-w-2xl mx-auto">
            Este e-book não explica o que é inteligência artificial.<br/>
            Não tem módulo introdutório. Não tem história de fundo.<br/>
            Tem um serviço pra você escolher. Tem o prompt pronto.<br/>
            Tem o passo a passo de como entregar.<br/>
            O resto é com você.
          </p>
          
          <button 
            onClick={scrollToOffer}
            className="bg-[#1a6b3c] hover:bg-[#145229] text-white px-8 py-4 font-black uppercase text-base md:text-lg transition-all inline-block">
            👉 QUERO PARAR DE ASSISTIR E COMEÇAR A FAZER
          </button>
        </div>
      </section>

      {/* BLOCO 2 — AGITAÇÃO */}
      <section className="py-16 px-4 bg-[#0a0a0a]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-center mb-8">
            ANTES DE CONTINUAR — UMA PERGUNTA HONESTA:
          </h2>
          
          <p className="text-xl md:text-2xl text-center text-white mb-16">
            Quantas abas sobre "como ganhar dinheiro com IA" você tem abertas agora?
          </p>
          
          <div className="space-y-6 mb-12">
            <div className="border-l-4 border-[#F5C518] pl-6 py-2">
              <p className="text-base md:text-lg">Você já assistiu pelo menos uns 4 vídeos sobre "IA pra iniciantes" — e ainda se considera iniciante</p>
            </div>
            <div className="border-l-4 border-[#F5C518] pl-6 py-2">
              <p className="text-base md:text-lg">Salvou uns 3 posts de "10 formas de usar IA pra ganhar dinheiro" e não usou nenhuma</p>
            </div>
            <div className="border-l-4 border-[#F5C518] pl-6 py-2">
              <p className="text-base md:text-lg">Chegou a testar o ChatGPT, achou interessante, fechou a aba e foi ver outra coisa</p>
            </div>
            <div className="border-l-4 border-[#F5C518] pl-6 py-2">
              <p className="text-base md:text-lg">Já pensou em oferecer algum serviço mas ficou travado no "mas o que exatamente eu ofereceria?"</p>
            </div>
            <div className="border-l-4 border-[#F5C518] pl-6 py-2">
              <p className="text-base md:text-lg">Acha que precisa estudar mais um pouco antes de dar o primeiro passo — há meses</p>
            </div>
          </div>
          
          <div className="border-4 border-[#F5C518] p-8 text-center">
            <p className="text-xl md:text-2xl font-black uppercase text-[#F5C518] leading-relaxed">
              SE VOCÊ BALANÇOU A CABEÇA PRA PELO MENOS TRÊS DESSES —<br/>
              VOCÊ NÃO TEM PROBLEMA DE CONHECIMENTO.<br/>
              VOCÊ TEM PROBLEMA DE EXECUÇÃO.<br/>
              E ESSE MATERIAL RESOLVE EXATAMENTE ISSO.
            </p>
          </div>
        </div>
      </section>

      {/* BLOCO 3 — REPOSICIONAMENTO */}
      <section className="py-16 px-4 bg-white text-[#0a0a0a]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-center mb-12">
            O PROBLEMA NÃO É A IA.<br/>
            É FICAR ESTUDANDO ELA SEM USAR PRA NADA.
          </h2>
          
          <div className="bg-[#0a0a0a] text-white p-8 md:p-12">
            <p className="text-lg md:text-xl leading-relaxed mb-8">
              Pequenos negócios não precisam de alguém que "entende de IA".<br/>
              Eles precisam de alguém que resolva um problema que eles<br/>
              não têm tempo, paciência ou conhecimento pra resolver sozinhos.
            </p>
            
            <div className="space-y-4 text-base md:text-lg">
              <p>Cardápio que só existe em papel.</p>
              <p>Instagram que parece abandonado.</p>
              <p>WhatsApp que demora horas pra responder.</p>
              <p>Site que não existe.</p>
            </div>
            
            <p className="text-lg md:text-xl leading-relaxed mt-8 text-[#F5C518] font-bold">
              Problemas simples. Que a IA resolve em minutos.<br/>
              Que eles pagariam pra alguém resolver hoje.<br/>
              Esse alguém pode ser você.<br/>
              Este material mostra como.
            </p>
          </div>
        </div>
      </section>

      {/* BLOCO 4 — O QUE VOCÊ APRENDE */}
      <section className="py-16 px-4 bg-[#F5C518] text-[#0a0a0a]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-center mb-12">
            O QUE TEM AQUI DENTRO — SEM ENROLAÇÃO:
          </h2>
          
          <div className="space-y-6 mb-12">
            <div className="flex items-start gap-4">
              <span className="text-2xl">✅</span>
              <p className="text-base md:text-lg font-bold">Como escolher UM serviço e parar de ficar em dúvida sobre por onde começar</p>
            </div>
            <div className="flex items-start gap-4">
              <span className="text-2xl">✅</span>
              <p className="text-base md:text-lg font-bold">Como chegar no cliente certo sem parecer vendedor desesperado</p>
            </div>
            <div className="flex items-start gap-4">
              <span className="text-2xl">✅</span>
              <p className="text-base md:text-lg font-bold">Como usar a IA pra executar o serviço do zero — com os prompts já escritos</p>
            </div>
            <div className="flex items-start gap-4">
              <span className="text-2xl">✅</span>
              <p className="text-base md:text-lg font-bold">Como entregar algo que parece feito por quem cobra caro por isso</p>
            </div>
            <div className="flex items-start gap-4">
              <span className="text-2xl">✅</span>
              <p className="text-base md:text-lg font-bold">Como apresentar o que você fez de um jeito que o cliente entenda o valor</p>
            </div>
            <div className="flex items-start gap-4">
              <span className="text-2xl">✅</span>
              <p className="text-base md:text-lg font-bold">Plano de ação para os primeiros 7 dias — dia a dia, sem achismo</p>
            </div>
          </div>
          
          <div className="bg-[#0a0a0a] text-[#F5C518] p-8 text-center">
            <p className="text-xl md:text-2xl font-black uppercase leading-relaxed">
              NÃO TEM "MÓDULO BÔNUS DE MENTALIDADE".<br/>
              NÃO TEM AULA DE MOTIVAÇÃO.<br/>
              TEM O QUE VOCÊ PRECISA PRA EXECUTAR. SÓ ISSO.
            </p>
          </div>
        </div>
      </section>

      {/* BLOCO 5 — SERVIÇOS */}
      <section className="py-16 px-4 bg-white text-[#0a0a0a]">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-center mb-6">
            OS SERVIÇOS QUE VOCÊ VAI APRENDER A ENTREGAR:
          </h2>
          
          <p className="text-center text-gray-600 text-sm md:text-base mb-12">
            Escolha um. Só um. Depois você expande. Primeiro, execute.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="border-4 border-[#0a0a0a] p-6">
              <h3 className="text-xl md:text-2xl font-black mb-4">Cardápio Digital com QR Code</h3>
              <p className="text-sm md:text-base leading-relaxed">
                Restaurantes, lanchonetes e deliveries ainda imprimem cardápio.
                Isso tem solução simples, visual e que o cliente percebe na hora.
                Execução: rápida. Demanda: alta. Concorrência na sua cidade: provavelmente nenhuma.
              </p>
            </div>
            
            <div className="border-4 border-[#0a0a0a] p-6">
              <h3 className="text-xl md:text-2xl font-black mb-4">Perfil Profissional no Instagram para Negócio Local</h3>
              <p className="text-sm md:text-base leading-relaxed">
                Bio que parece amadora, destaques vazios, sem identidade.
                Todo comércio local tem esse problema. Quase nenhum sabe resolver.
                Com os prompts certos, você entrega algo que parece de agência.
              </p>
            </div>
            
            <div className="border-4 border-[#0a0a0a] p-6">
              <h3 className="text-xl md:text-2xl font-black mb-4">Respostas Padronizadas para WhatsApp</h3>
              <p className="text-sm md:text-base leading-relaxed">
                O dono responde a mesma pergunta 30 vezes por dia.
                Você organiza isso pra ele de uma vez.
                Simples. Útil. Valorizado por quem vive esse caos todo dia.
              </p>
            </div>
            
            <div className="border-4 border-[#0a0a0a] p-6">
              <h3 className="text-xl md:text-2xl font-black mb-4">Página de Apresentação para Negócio Local</h3>
              <p className="text-sm md:text-base leading-relaxed">
                Negócio sem presença online em 2025 é negócio invisível.
                Uma página simples já resolve. Você aprende a montar sem programar nada.
              </p>
            </div>
            
            <div className="border-4 border-[#0a0a0a] p-6 md:col-span-2 bg-[#F5C518]">
              <div className="flex items-start gap-2 mb-4">
                <h3 className="text-xl md:text-2xl font-black">Análise de Perfil com Recomendações Práticas</h3>
                <span className="text-xl">⭐</span>
              </div>
              <p className="text-sm md:text-base leading-relaxed font-bold">
                Esse é o que parece mais difícil e é o mais fácil de entregar.
                Um documento organizado com observações e sugestões do perfil do cliente.
                A IA estrutura. Você revisa. O cliente recebe algo que parece consultoria.
                Alta percepção de valor. Baixo tempo de execução. Aprenda esse primeiro.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOCO 6 — CASES COM CONTEXTO */}
      <section className="py-16 px-4 bg-[#0a0a0a]">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-center mb-4">
            GENTE COMUM QUE PAROU DE ESTUDAR E COMEÇOU A FAZER:
          </h2>
          
          <p className="text-center text-gray-400 text-sm mb-12">
            Relatos reais. Resultados individuais — os seus dependem de você.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="text-center">
              <img 
                src="https://static.lumi.new/55/55075b9ed39383fffe62d64610c21caf.png" 
                alt="Depoimento Cibele"
                className="w-full max-w-xs mx-auto mb-4 border-4 border-[#F5C518]"
              />
              <p className="text-sm text-gray-400">Cibele</p>
            </div>
            
            <div className="text-center">
              <img 
                src="https://static.lumi.new/01/01620658c80c61e82fd001d054477274.png" 
                alt="Depoimento João"
                className="w-full max-w-xs mx-auto mb-4 border-4 border-[#F5C518]"
              />
              <p className="text-sm text-gray-400">João</p>
            </div>
            
            <div className="text-center">
              <img 
                src="https://static.lumi.new/c4/c45c557d652c8f17a8073e4a36cd9f0d.png" 
                alt="Depoimento Rodrigo"
                className="w-full max-w-xs mx-auto mb-4 border-4 border-[#F5C518]"
              />
              <p className="text-sm text-gray-400">Rodrigo</p>
            </div>
          </div>
          
          <p className="text-center text-gray-500 text-xs max-w-2xl mx-auto">
            Experiências individuais. Resultados variam conforme dedicação,
            contexto e esforço de cada pessoa.
          </p>
        </div>
      </section>

      {/* BLOCO 7 — QUALIFICAÇÃO */}
      <section className="grid md:grid-cols-2">
        {/* É PRA VOCÊ SE */}
        <div className="py-16 px-4 bg-[#F5C518] text-[#0a0a0a]">
          <div className="max-w-xl mx-auto">
            <h3 className="text-2xl md:text-4xl font-black uppercase mb-8 text-center">
              É PRA VOCÊ SE:
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <span className="text-xl">✅</span>
                <p className="text-sm md:text-base font-bold">Você consume conteúdo sobre isso há um tempo e ainda não executou nada</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xl">✅</span>
                <p className="text-sm md:text-base font-bold">Você quer algo concreto — não mais teoria pra processar</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xl">✅</span>
                <p className="text-sm md:text-base font-bold">Você prefere aprender fazendo do que estudar pra se sentir pronto</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xl">✅</span>
                <p className="text-sm md:text-base font-bold">Você tem tempo limitado e não quer desperdiçar com o que não é essencial</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xl">✅</span>
                <p className="text-sm md:text-base font-bold">Você não quer aparecer, criar conteúdo ou construir uma audiência agora</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* NÃO É PRA VOCÊ SE */}
        <div className="py-16 px-4 bg-[#0a0a0a] text-white">
          <div className="max-w-xl mx-auto">
            <h3 className="text-2xl md:text-4xl font-black uppercase mb-8 text-center">
              NÃO É PRA VOCÊ SE:
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <span className="text-xl">❌</span>
                <p className="text-sm md:text-base font-bold">Você quer resultado sem nenhuma ação da sua parte</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xl">❌</span>
                <p className="text-sm md:text-base font-bold">Você já tem um serviço digital rodando e escalando</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xl">❌</span>
                <p className="text-sm md:text-base font-bold">Você busca aprofundamento técnico em IA</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xl">❌</span>
                <p className="text-sm md:text-base font-bold">Você prefere mais conteúdo pra consumir antes de decidir qualquer coisa</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BLOCO 8 — MÉTODO */}
      <section className="py-16 px-4 bg-[#F5C518] text-[#0a0a0a]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-center mb-12">
            COMO FUNCIONA NA PRÁTICA:
          </h2>
          
          <div className="space-y-6 mb-12">
            <div className="bg-[#0a0a0a] text-white p-6 border-l-8 border-[#F5C518]">
              <h4 className="text-xl md:text-2xl font-black text-[#F5C518] mb-2">1 — ESCOLHA UM SERVIÇO</h4>
              <p className="text-sm md:text-base">Só um. O material ajuda você a decidir qual faz mais sentido pro seu perfil.</p>
            </div>
            
            <div className="bg-[#0a0a0a] text-white p-6 border-l-8 border-[#F5C518]">
              <h4 className="text-xl md:text-2xl font-black text-[#F5C518] mb-2">2 — SIGA O PASSO A PASSO</h4>
              <p className="text-sm md:text-base">Cada serviço tem roteiro próprio. Você não precisa inventar nada.</p>
            </div>
            
            <div className="bg-[#0a0a0a] text-white p-6 border-l-8 border-[#F5C518]">
              <h4 className="text-xl md:text-2xl font-black text-[#F5C518] mb-2">3 — USE OS PROMPTS PRONTOS</h4>
              <p className="text-sm md:text-base">Já testados. Já ajustados. Você adapta pro contexto do cliente e executa.</p>
            </div>
            
            <div className="bg-[#0a0a0a] text-white p-6 border-l-8 border-[#F5C518]">
              <h4 className="text-xl md:text-2xl font-black text-[#F5C518] mb-2">4 — APRESENTE</h4>
              <p className="text-sm md:text-base">O material tem o script de abordagem. Você não vai travar na hora de falar.</p>
            </div>
            
            <div className="bg-[#0a0a0a] text-white p-6 border-l-8 border-[#F5C518]">
              <h4 className="text-xl md:text-2xl font-black text-[#F5C518] mb-2">5 — ENTREGUE</h4>
              <p className="text-sm md:text-base">Com qualidade. Com organização. Do jeito que o cliente percebe valor.</p>
            </div>
            
            <div className="bg-[#0a0a0a] text-white p-6 border-l-8 border-[#F5C518]">
              <h4 className="text-xl md:text-2xl font-black text-[#F5C518] mb-2">6 — REPITA</h4>
              <p className="text-sm md:text-base">Com o próximo. Com outro serviço. Do seu jeito, no seu ritmo.</p>
            </div>
          </div>
          
          <div className="bg-[#0a0a0a] text-white p-8 text-center">
            <p className="text-lg md:text-xl font-black uppercase leading-relaxed">
              SEM FUNIL DE 12 ETAPAS.<br/>
              SEM "MÉTODO EXCLUSIVO COM NOME PRÓPRIO".<br/>
              FUNCIONA PORQUE É SIMPLES — E SIMPLES É O QUE VOCÊ VAI EXECUTAR.
            </p>
          </div>
        </div>
      </section>

      {/* BLOCO 9 — OFERTA */}
      <section id="oferta" className="py-16 px-4 bg-[#0a0a0a]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-black uppercase leading-tight mb-8 text-white">
            VOCÊ JÁ SABE O SUFICIENTE PRA COMEÇAR.<br/>
            FALTAVA SÓ SABER O QUE FAZER COM ISSO.
          </h2>
          
          <p className="text-2xl md:text-3xl font-bold mb-12 text-white">
            Agora você sabe.
          </p>
          
          <div className="mb-8">
            <p className="text-sm md:text-base text-white mb-6">
              <span className="line-through opacity-60">R$47</span>
              <span className="mx-3 text-2xl md:text-3xl font-black">R$27</span>
              <span className="text-sm">— Oferta de lançamento</span>
            </p>
          </div>
          
          <a 
            href="https://pay.kiwify.com.br/j0HCPzr"
            target="_blank"
            rel="noopener noreferrer"
            className="go-to-checkout bg-[#1a6b3c] hover:bg-[#145229] text-white px-10 py-5 font-black uppercase text-lg md:text-xl transition-all inline-block mb-6">
            👉 QUERO ACESSAR AGORA — R$27
          </a>
          
          <p className="text-xs md:text-sm text-gray-400">
            🔒 Pagamento seguro · Garantia de 7 dias · Acesso imediato
          </p>
        </div>
      </section>

      {/* RODAPÉ */}
      <footer className="py-12 px-4 bg-[#0a0a0a] border-t-4 border-[#F5C518]">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm text-gray-400 mb-4">
            © 2025 COMEÇAR COM IA. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-xs text-gray-500">
            <a href="#" className="hover:text-[#F5C518]">Política de Privacidade</a>
            <a href="#" className="hover:text-[#F5C518]">Termos de Uso</a>
            <a href="#" className="hover:text-[#F5C518]">Contato</a>
          </div>
        </div>
      </footer>

      {/* BOTÃO STICKY FIXO */}
      <div className="fixed bottom-0 left-0 right-0 bg-[#1a6b3c] p-4 shadow-lg z-50 border-t-4 border-[#F5C518]">
        <div className="max-w-4xl mx-auto text-center">
          <button 
            onClick={scrollToOffer}
            className="bg-[#F5C518] hover:bg-[#e0b315] text-[#0a0a0a] px-8 py-3 font-black uppercase text-sm md:text-base transition-all inline-block w-full md:w-auto">
            👉 ACESSAR POR R$27
          </button>
        </div>
      </div>
    </div>
  );
}

export default New;
